"use client";

import type { PropsWithChildren, ReactNode } from "react";

import { SWRConfig } from "swr";

import { logger } from "@/src/infrastructure/datadog/datadog";

export function SwrProvider({ children }: PropsWithChildren): ReactNode {
  return <SWRConfig value={{ onError }}>{children}</SWRConfig>;
}

// Use in tests that render components calling useSWR. It isolates the cache between
// test cases, so stale data does not leak across tests. Not needed for useSWRMutation.
// https://swr.vercel.app/docs/advanced/cache#reset-cache-between-test-cases
// eslint-disable-next-line react/no-multi-comp
export function SwrProviderTest({ children }: PropsWithChildren): ReactNode {
  return (
    <SWRConfig value={{ onError, provider: () => new Map() }}>
      {children}
    </SWRConfig>
  );
}

function onError(err: Error, key: string): void {
  logger.error(`SWR error for ${key}`, {}, err);
}
